var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.624,
    y1: 15.969,
    x2: 2.624,
    y2: 11.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#81ce31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#86d633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 9.026,
    y1: 18,
    x2: 9.026,
    y2: 13.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#81ce31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#86d633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 15.376,
    y1: 16.001,
    x2: 15.376,
    y2: 11.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#81ce31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#86d633"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.509 7.868h-5.457a.293.293 0 01-.293-.293V5.491H8.293v2.084A.294.294 0 018 7.868H2.479a.587.587 0 00-.587.587v2.7h1.466v-1.5a.294.294 0 01.294-.293h4.641v3.918h1.466V9.368h4.577a.293.293 0 01.293.293v1.53H16.1V8.455a.587.587 0 00-.591-.587z",
    fill: "#50e6ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.029,
    width: 5.881,
    height: 5.881,
    rx: 0.532,
    fill: "#0078d4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.158,
    y: 1.13,
    width: 3.622,
    height: 3.622,
    rx: 0.328,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.223,
    y: 11.167,
    width: 4.802,
    height: 4.802,
    rx: 0.435,
    fill: "url(#a)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.624,
    y: 13.198,
    width: 4.802,
    height: 4.802,
    rx: 0.435,
    fill: "url(#b)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.975,
    y: 11.199,
    width: 4.802,
    height: 4.802,
    rx: 0.435,
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/Workflow.ca67f82dee8abe5862f30b3d472de4e8.svg";
export { ForwardRef as ReactComponent };